module.exports = __webpack_public_path__ + "static/media/stw.9ecf0123.jpeg";